export default function ArrangementLoading() {
  return (
    <>
      {/* Progress bar skeleton */}
      <div className="mx-auto w-full max-w-5xl px-4 pb-6 pt-6 sm:pt-8">
        <div className="flex justify-between gap-4">
          {[1, 2, 3, 4].map((i) => (
            <div key={i} className="flex flex-col items-center gap-1.5">
              <div className="h-8 w-8 animate-pulse rounded-full bg-oat" />
              <div className="hidden h-4 w-20 animate-pulse rounded bg-oat sm:block" />
            </div>
          ))}
        </div>
      </div>

      {/* Content skeleton */}
      <div className="mx-auto w-full max-w-5xl flex-1 px-4 pb-24">
        <div className="mb-8 flex flex-col items-center gap-3">
          <div className="h-10 w-80 animate-pulse rounded bg-oat" />
          <div className="h-5 w-64 animate-pulse rounded bg-oat" />
        </div>

        <div className="grid grid-cols-1 gap-8 md:grid-cols-3">
          {[1, 2, 3].map((i) => (
            <div key={i} className="h-80 animate-pulse rounded-lg bg-oat" />
          ))}
        </div>
      </div>
    </>
  );
}
